<template>
  <div class="">
    <VuePhoneNumberInput
      v-model="vModel"
      color="#00B9E8"
      error-color="#EA5455"
      :error="!!errors"
      :countriesHeight="25"
      :default-country-code="phoneCode ?? 'US'"
      @update="setValue"
    />
  </div>
</template>
<script>
import "vue-phone-number-input/dist/vue-phone-number-input.css"
import VuePhoneNumberInput from "vue-phone-number-input"

export default {
  name: "PhoneInput",
  components: { VuePhoneNumberInput },
  props: ["errors", "value", "phoneCode"],
  mounted() {
  },
  data() {
    return {
      isValid: null,
      vModel: this.value
    }
  },
  methods: {
    setValue(event) {
      console.log(event)
      console.log(event.formattedNumber)
      this.$emit("input", event)
      this.isValid = event.isValid
    }
  }
}
</script>

<style lang="scss">
@import "vue-phone-number-input/dist/vue-phone-number-input.css";

.vue-phone-number-input {
  z-index: 100;
  position: relative;
}
</style>
